import { where } from 'firebase/firestore'

import FirestoreService from '../services/firestoreService'

import { UserLegalClausesModel } from '../models/user-legal-clauses/user-legal-clauses.model'

import { CONST } from '../const/const'
import { ILegalClauseInterface } from '../models/user-legal-clauses/user-legal-clauses.interface'
const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

export const getAllClauses = async (ownerId: string) => {
  const respData: ILegalClauseInterface[] = []
  try {
    const clauses = await FirestoreService.filterItems(COLLECTIONS.USER_LEGAL_CLAUSES.NAME, [
      where(COLLECTIONS.USER_LEGAL_CLAUSES.FIELDS.OWNER_ID.KEY, '==', ownerId),
    ])

    if (clauses.size) {
      clauses?.forEach((doc) => {
        let clauseDataModel = UserLegalClausesModel.fromFirestoreDoc(doc).toObject()
        respData.push(clauseDataModel)
      })
      return respData
    }
  } catch (error) {
    console.error(error, 'error')
  }
}
